
import { Component, Vue} from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from 'moment-timezone';   
import "@/store/modules/application";
const applicationState = namespace("Application");

import "@/store/modules/common";
const commonState = namespace("Common");

import NavigationSidebar from "./NavigationSidebar.vue";
import DeceasedStep from "./steps/deceased/DeceasedStep.vue";
import DeceasedWillStep from "./steps/will/DeceasedWillStep.vue";
import RelatedPeopleStep from "./steps/relatedPeople/RelatedPeopleStep.vue";
import ApplicantInfoStep from "./steps/applicant/ApplicantInfoStep.vue";
import NotifyStep from "./steps/notify/NotifyStep.vue";
import BelongingsStep from "./steps/belongings/BelongingsStep.vue";
import NoWillNotifyStep from "./steps/noWillNotify/NoWillNotifyStep.vue";
import OverviewStep from "./steps/overview/OverviewStep.vue";
import Review from "./steps/review/ReviewStep.vue"
import Submit from "./steps/submit/StepSubmit.vue";
import NextStep from "./steps/nextSteps/NextStep.vue"

import * as surveyEnv from "@/components/survey/survey-glossary"
import { stepInfoType } from '@/types/Application';

@Component({
    components: {
        NavigationSidebar,
        DeceasedStep,
        DeceasedWillStep,
        RelatedPeopleStep,
        ApplicantInfoStep,
        NotifyStep,
        BelongingsStep,
        NoWillNotifyStep,
        OverviewStep,
        Review,
        Submit,
        NextStep       
    }
})

export default class Surveys extends Vue {

    @applicationState.State
    public steps!: stepInfoType[];

    @applicationState.State
    public userType!: string;

    @applicationState.State
    public currentStep!: number;

    @commonState.State
    public existingApplication!: Boolean;

    @applicationState.Action
    public UpdateApplicationId!: (newApplicationId) => void

    @applicationState.Action
    public UpdateLastUpdated!: (newLastUpdated) => void

    error = "";
    surveyInitiated = false;
  
    beforeCreate() {    
        surveyEnv.loadGlossary();
        // console.log('here in survey')
    }

    mounted() {
        this.surveyInitiated = false;
        if (this.existingApplication){
            this.surveyInitiated = true;
        } else {
            this.initiateApplication();
        }
        
    }

    public getCurrentStepIndex() {
        return this.currentStep;
    }

    public getStep(stepIndex) {
        const step = this.steps[stepIndex];
        // console.log(stepIndex);
        // console.log(step)
        return step;
    }

    public initiateApplication() {

        this.$store.commit("Application/init");
        const lastUpdated = moment().format();
        this.UpdateLastUpdated(lastUpdated);
        
        const application = this.$store.state.Application;
        const url = "/app/"
        const header = {
            responseType: "json",
            headers: {
                "Content-Type": "application/json",
            }
        }
        this.$http.post(url, application, header)
        .then(res => {
            this.UpdateApplicationId(res.data.app_id)
            this.error = "";
            this.surveyInitiated = true;
            
        }, err => {
            console.error(err);
            this.error = err;
        });
    }

};
